import { useCallback, useEffect, useState } from 'react';
import { getFloorState, FloorState } from '../services/floorStateService';

export function useFloorState() {
  const [data, setData] = useState<FloorState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    getFloorState()
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
    window.addEventListener('focus', reload);
    return () => window.removeEventListener('focus', reload);
  }, [reload]);

  return { data, loading, error, reload };
}
